<script>
import common from './common.vue';
export default {
  mixins: [common],
  data() {
    return {
      fanhuiIcon: `${this.$cdnLink}/wanXin/yssl/close.png`,
    }
  }
};
</script>
<style lang="scss" module>
@import '../../../assets/css/yssl.scss';

.wrap {
  width: 6.4rem;
  height: 5.2rem;
  font-size: 0.23rem;
  background: url('#{$cdn-url}/wanXin/yssl/bg1.png?v=1') no-repeat;
  background-size: 100% 100%;
  padding-left: .2rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 10;
  > header {
    padding-top: 0.35rem;
    text-align: center;
    color: $primary-color;
    > p {
      font-size: 0.3rem;
      height: 0.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }
    .fanhui {
      position: absolute;
      top: 0.45rem;
      right: 0.46rem;
      width: .3rem;
      height: .3rem;
    }
    .priceWrap {
      position: relative;
      height: 0.3rem;
      margin-bottom: 0.1rem;
    }
    .price,
    .couponPrice {
      font-size: 0.36rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      font-family: 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB', 'Helvetica Neue', 'Helvetica', 'Arial';
      font-style: normal;
    }
    .couponPrice {
      font-size: 0.4rem;
      text-align: center;
      margin-left: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .normal {
        text-decoration: line-through;
        font-weight: 400;
        font-size: 0.28rem;
        margin-left: 0.1rem;
      }
    }
    > .voucher {
      background: #EADCD0;
      color: #FFFFFF;
      margin: .2rem .5rem;
      font-size: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.15rem 0.2rem 0.15rem 0.28rem;
      border-radius: 1rem;
      &.noCoupon {
        background: #EADCD0;
        > span {
          color: #FFFFFF;
        }
      }
      > span {
        color: $primary-color;
        font-size: 0.28rem;
      }
      .useCoupon {
        border-radius: 0.03rem;
        padding: 0.08rem 0.12rem 0.06rem 0.12rem;
        font-size: 0.22rem;
        color: $primary-color;
        .saw {
          background: $primary-color-1;
          padding: 1px 2px;
          border-radius: 2px;
          margin-right: 4px;
          color: #FFFFFF;
        }
        &.noCoupon {
          background: #F2F2F2;
          color: #343433;
        }
        .icon {
          font-size: 11px;
          margin-left: 4px;
        }
      }
      .couponContent {
        border-radius: 0.18rem;
        font-size: 0.22rem;
        color: #5f1d10;
        display: flex;
        align-items: center;
        > img {
          width: 0.28rem;
          height: 0.28rem;
          margin-right: 0.05rem;
        }
        > span {
          border-radius: 0.03rem;
          padding: 0.08rem 0.12rem 0.06rem 0.12rem;
          background: linear-gradient(90deg, #e9be69, #fbd58d);
        }
      }
    }
    > .couponHint {
      font-size: 0.19rem;
      text-align: center;
      color: #FFFFFF;
      > img {
        width: 0.19rem;
        height: 0.19rem;
        display: inline-block;
        vertical-align: middle;
        margin-right: 2px;
      }
      > p {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  > main {
    .content {
      padding: 0.1rem .4rem;
      font-weight: bold;
      text-align: center;
      font-size: 0.28rem;
      .payType {
        overflow-x: auto;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .listItem {
          margin-bottom: 0.1rem;
          padding-bottom: 0.1rem;
          width: 1.8rem;
          margin: 0 0.1rem;
          .iconItem {
            background: #30b4ff;
            padding: 0.15rem 0;
            text-align: center;
            border-radius: 8px;
            font-size: 0.24rem;
            color: #ffffff;
            position: relative;
            > img {
              width: 0.5rem;
              height: 0.5rem;
              display: inline-block;
              margin-bottom: 0.05rem;
            }
            &:active {
              opacity: 0.8;
            }
            .recommend {
              position: absolute;
              top: 0;
              left: 0.16rem;
              width: 0.2rem;
              height: 0.4rem;
            }
          }
          .radio {
            display: flex;
            justify-content: center;
            margin-top: 0.1rem;
          }
        }
      }
    }
    .btnGroup {
      position: absolute;
      width: 90%;
      height: 0.68rem;
      bottom: .4rem;
      left: 6%;
      right: 5%;
      display: flex;
      justify-content: center;
    }
    .btn {
      background: url('#{$cdn-url}/wanXin/yssl/button3.png?v=1') no-repeat;
      background-size: 100% 100%;
      color: #FFFFFF;
      border: none;
      padding: 0 0.6rem;
      height: 0.68rem;
      line-height: 0.68rem;
      font-size: 0.24rem;
      margin: 0.1 0.2rem;
      &.alone {
        padding: 0 .7rem;
      }
    }
    .submitBtn {
      @include common-button();
    }
    .orderFrame {
      z-index: 999;
      position: fixed;
      width: 100%;
      min-height: 100%;
      text-align: center;
      background: #f4f4f4;
      margin: auto;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      border: 0;
    }
    .payQrCode {
      display: block;
      width: 2rem;
      height: 2rem;
      margin: .1rem auto;
    }
    .payQrCodeTip {
      text-align: center;
      font-weight: 800;
    }
  }
  &.fullScreen {
    width: 320px;
    height: 280px;
    font-size: 11px;
    background: url('#{$cdn-url}/wanXin/legend/l-5.png?v=1') no-repeat;
    background-size: 100% 100%;
    padding-left: 10px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: $h5-window;
    > header {
      padding-top: .9rem;
      text-align: center;
      color: #ffffff;
      > p {
        font-size: 15px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
      }
      .fanhui {
        position: absolute;
        top: 36px;
        right: 13px;
        width: 29px;
        height: 30px;
      }
      .priceWrap {
        position: relative;
        height: 15px;
        margin-bottom: 5px;
      }
      .price,
      .couponPrice {
        font-size: 18px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        font-family: 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB', 'Helvetica Neue', 'Helvetica', 'Arial';
        font-style: normal;
      }
      .couponPrice {
        font-size: 20px;
        text-align: center;
        margin-left: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        .normal {
          text-decoration: line-through;
          font-weight: 400;
          font-size: 14px;
          margin-left: 5px;
        }
      }
      > .voucher {
        background: #27231b;
        border: 4.86px solid;
        border-image: linear-gradient(0deg, #130f0d 0%, #130f0d 8%, #371e14 50%, #130f0d 92%, #130f0d 100%) 7 7;
        box-shadow: 0px 3.47px 13.86px 0.17px rgba(5,0,0,0.75), 0px 0px 12.51px 0px rgba(255,161,82,0.30) inset; 
        color: #FFFFFF;
        margin: 0 25px;
        font-size: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px 6px 5px 14px;
        &.noCoupon {
          background: rgba(255, 255, 255, 0.34);
          > span {
            color: #FFFFFF;
          }
        }
        > span {
          color: $primary-color;
          font-size: 14px;
        }
        .useCoupon {
          border-radius: 1.5px;
          padding: 4px 6px 3px 6px;
          font-size: 11px;
          color: $primary-color;
          &.noCoupon {
            background: #F2F2F2;
            color: #343433;
          }
        }
        .couponContent {
          border-radius: 9px;
          font-size: 11px;
          color: #5f1d10;
          display: flex;
          align-items: center;
          > img {
            width: 14px;
            height: 14px;
            margin-right: 2.5px;
          }
          > span {
            border-radius: 2px;
            padding: 4px 6px 3px 6px;
            background: linear-gradient(90deg, #e9be69, #fbd58d);
          }
        }
      }
      > .couponHint {
        font-size: 9px;
        text-align: center;
        color: #FFFFFF;
        > img {
          width: 9px;
          height: 9px;
          display: inline-block;
          vertical-align: middle;
        }
        > p {
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
    > main {
      .content {
        padding: 5px 20px;
        font-weight: bold;
        text-align: center;
        font-size: 14px;
        .payType {
          overflow-x: auto;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .listItem {
            margin-bottom: 5px;
            padding-bottom: 5px;
            width: 90px;
            margin: 0 5px;
            .iconItem {
              background: #30b4ff;
              padding: 7px 0;
              text-align: center;
              border-radius: 8px;
              font-size: 12px;
              color: #ffffff;
              position: relative;
              > img {
                width: 25px;
                height: 25px;
                display: inline-block;
                margin-bottom: 2px;
              }
              &:active {
                opacity: 0.8;
              }
              .recommend {
                position: absolute;
                top: 0;
                left: 8px;
                width: 10px;
                height: 20px;
              }
            }
            .radio {
              display: flex;
              justify-content: center;
              margin-top: 5px;
            }
          }
        }
      }
      .btnGroup {
        position: absolute;
        width: 90%;
        height: 34px;
        bottom: 30px;
        left: 5%;
        right: 5%;
        display: flex;
        justify-content: center;
      }
      .btn {
        background: url('#{$cdn-url}/wanXin/legend/l-3.png?v=1') no-repeat;
        background-size: 100% 100%;
        color: #FFE85D;
        border: none;
        padding: 0 30px;
        height: 34px;
        line-height: 34px;
        font-size: 12px;
        margin: 0 10px;
        &.alone {
          padding: 0 35px;
        }
      }
      .submitBtn {
        @include full-screen-button();
      }
      .orderFrame {
        z-index: 999;
        position: fixed;
        width: 100%;
        min-height: 100%;
        text-align: center;
        background: #f4f4f4;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        border: 0;
      }
    }
  }
}
</style>
